import { useState } from "react"

import { useLogger } from "@/hooks/useLogger"
import { TABS_DEMO } from "../../const"
import { HardenModal } from "./HardenModal"
import { HardeningBanner } from "./HardeningBanner"
import { useHardening } from "./useHardening"

import type { HardeningBelowTabsProps } from "./HardenAgent.types"

// The banner under the drawer's tab bar and the modal it opens.
export const HardeningBelowTabs = (props: HardeningBelowTabsProps) => {
  const { record, actions } = props
  const { agent, suggestions } = useHardening({ record })
  const { logger, EVENTS } = useLogger()
  const [open, setOpen] = useState(false)

  if (!agent) return null

  const showPolicyTab = () => actions.onChangeActiveKey(TABS_DEMO.aiPolicy)

  return (
    <>
      <HardeningBanner
        suggestions={suggestions}
        onHarden={() => {
          logger.info(EVENTS.ANALYTIC_EVENTS.AI_POLICY.HARDEN.VIEWED, {
            agent_id: agent.id,
            suggestions_count: suggestions.length,
            entry: "banner"
          })
          showPolicyTab()
          setOpen(true)
        }}
      />
      <HardenModal
        open={open}
        agent={agent}
        suggestions={suggestions}
        onClose={() => setOpen(false)}
        onApproved={() => setOpen(false)}
      />
    </>
  )
}
